 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"index": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"index": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "assets/js/" + ({"admin":"admin","admin/callback":"admin/callback","admin/categories":"admin/categories","admin/categories/create":"admin/categories/create","admin/delivery-terms":"admin/delivery-terms","admin/delivery-terms/create":"admin/delivery-terms/create","admin/districts":"admin/districts","admin/districts/create":"admin/districts/create","admin/faq":"admin/faq","admin/faq/create":"admin/faq/create","admin/hit-products":"admin/hit-products","admin/hit-products/create":"admin/hit-products/create","admin/manufacturers":"admin/manufacturers","admin/manufacturers/create":"admin/manufacturers/create","admin/options":"admin/options","admin/options/create":"admin/options/create","admin/orders":"admin/orders","admin/pages":"admin/pages","admin/pages/create":"admin/pages/create","admin/pages/edit/:id":"admin/pages/edit/:id","admin/payment-terms":"admin/payment-terms","admin/payment-terms/create":"admin/payment-terms/create","admin/product-sections":"admin/product-sections","admin/product-sections/create":"admin/product-sections/create","admin/products":"admin/products","admin/products/create":"admin/products/create","admin/products/edit/:id":"admin/products/edit/:id","admin/promocodes":"admin/promocodes","admin/promocodes/create~admin/promocodes/edit":"admin/promocodes/create~admin/promocodes/edit","admin/promocodes/create":"admin/promocodes/create","admin/promocodes/edit":"admin/promocodes/edit","admin/sliders":"admin/sliders","admin/sliders/create":"admin/sliders/create","auth":"auth","auth/login":"auth/login","error":"error","home":"home"}[chunkId]||chunkId) + "." + {"admin":"55ea6c6c","admin/callback":"1bd049e1","admin/categories":"f0310128","admin/categories/create":"45194aef","admin/delivery-terms":"9b80ec2c","admin/delivery-terms/create":"269ef3b7","admin/districts":"3221e466","admin/districts/create":"c36aabce","admin/faq":"b07d50ed","admin/faq/create":"58bc72c6","admin/hit-products":"022f3949","admin/hit-products/create":"c1d9d8a1","admin/manufacturers":"bd6bff41","admin/manufacturers/create":"c82afc01","admin/options":"92d91487","admin/options/create":"e6c4dcc5","admin/orders":"1cbc2a14","admin/pages":"d83b35a6","admin/pages/create":"e22bd7ac","admin/pages/edit/:id":"113aea21","admin/payment-terms":"431e1382","admin/payment-terms/create":"8eacc48f","admin/product-sections":"d7dcd854","admin/product-sections/create":"2dda2311","admin/products":"9c0bc246","admin/products/create":"7d9a1977","admin/products/edit/:id":"c694bd4c","admin/promocodes":"ca8de057","admin/promocodes/create~admin/promocodes/edit":"2b360522","admin/promocodes/create":"29bec305","admin/promocodes/edit":"e536499e","admin/sliders":"9b0ef3d7","admin/sliders/create":"48de50b2","auth":"938f6cd9","auth/login":"abca2fa2","chunk-13753184":"71a18245","chunk-17c612d8":"b4722489","chunk-19901099":"8168fa5a","chunk-1a5e133a":"89ff204d","chunk-1a6a4dfc":"1b382b84","chunk-1cc87535":"f1c8611a","chunk-1f910687":"0f70cdcf","chunk-20dd8a1b":"2169aff8","chunk-67043ddc":"bffee286","chunk-6ab991c0":"6fc7edf0","chunk-6b872f06":"d61291b3","chunk-6c46d2d3":"87956073","chunk-6d49bd8c":"ea45dfef","chunk-6e3ae64a":"813545b6","chunk-6f753ec7":"d7dc06b9","chunk-6fbdfde8":"c6df7751","error":"2fddcff5","home":"04596a96"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"admin/products":1,"chunk-13753184":1,"chunk-17c612d8":1,"chunk-19901099":1,"chunk-1a5e133a":1,"chunk-1a6a4dfc":1,"chunk-1cc87535":1,"chunk-1f910687":1,"chunk-20dd8a1b":1,"chunk-67043ddc":1,"chunk-6ab991c0":1,"chunk-6b872f06":1,"chunk-6c46d2d3":1,"chunk-6d49bd8c":1,"chunk-6e3ae64a":1,"chunk-6f753ec7":1,"chunk-6fbdfde8":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "assets/css/" + ({"admin":"admin","admin/callback":"admin/callback","admin/categories":"admin/categories","admin/categories/create":"admin/categories/create","admin/delivery-terms":"admin/delivery-terms","admin/delivery-terms/create":"admin/delivery-terms/create","admin/districts":"admin/districts","admin/districts/create":"admin/districts/create","admin/faq":"admin/faq","admin/faq/create":"admin/faq/create","admin/hit-products":"admin/hit-products","admin/hit-products/create":"admin/hit-products/create","admin/manufacturers":"admin/manufacturers","admin/manufacturers/create":"admin/manufacturers/create","admin/options":"admin/options","admin/options/create":"admin/options/create","admin/orders":"admin/orders","admin/pages":"admin/pages","admin/pages/create":"admin/pages/create","admin/pages/edit/:id":"admin/pages/edit/:id","admin/payment-terms":"admin/payment-terms","admin/payment-terms/create":"admin/payment-terms/create","admin/product-sections":"admin/product-sections","admin/product-sections/create":"admin/product-sections/create","admin/products":"admin/products","admin/products/create":"admin/products/create","admin/products/edit/:id":"admin/products/edit/:id","admin/promocodes":"admin/promocodes","admin/promocodes/create~admin/promocodes/edit":"admin/promocodes/create~admin/promocodes/edit","admin/promocodes/create":"admin/promocodes/create","admin/promocodes/edit":"admin/promocodes/edit","admin/sliders":"admin/sliders","admin/sliders/create":"admin/sliders/create","auth":"auth","auth/login":"auth/login","error":"error","home":"home"}[chunkId]||chunkId) + "." + {"admin":"31d6cfe0","admin/callback":"31d6cfe0","admin/categories":"31d6cfe0","admin/categories/create":"31d6cfe0","admin/delivery-terms":"31d6cfe0","admin/delivery-terms/create":"31d6cfe0","admin/districts":"31d6cfe0","admin/districts/create":"31d6cfe0","admin/faq":"31d6cfe0","admin/faq/create":"31d6cfe0","admin/hit-products":"31d6cfe0","admin/hit-products/create":"31d6cfe0","admin/manufacturers":"31d6cfe0","admin/manufacturers/create":"31d6cfe0","admin/options":"31d6cfe0","admin/options/create":"31d6cfe0","admin/orders":"31d6cfe0","admin/pages":"31d6cfe0","admin/pages/create":"31d6cfe0","admin/pages/edit/:id":"31d6cfe0","admin/payment-terms":"31d6cfe0","admin/payment-terms/create":"31d6cfe0","admin/product-sections":"31d6cfe0","admin/product-sections/create":"31d6cfe0","admin/products":"7fec0d11","admin/products/create":"31d6cfe0","admin/products/edit/:id":"31d6cfe0","admin/promocodes":"31d6cfe0","admin/promocodes/create~admin/promocodes/edit":"31d6cfe0","admin/promocodes/create":"31d6cfe0","admin/promocodes/edit":"31d6cfe0","admin/sliders":"31d6cfe0","admin/sliders/create":"31d6cfe0","auth":"31d6cfe0","auth/login":"31d6cfe0","chunk-13753184":"63f63cad","chunk-17c612d8":"abaa7cb4","chunk-19901099":"5a337af4","chunk-1a5e133a":"2ad73002","chunk-1a6a4dfc":"46ad191c","chunk-1cc87535":"72540abe","chunk-1f910687":"cc1e1a94","chunk-20dd8a1b":"cf12cf36","chunk-67043ddc":"f61db1c8","chunk-6ab991c0":"6d402759","chunk-6b872f06":"5b77435d","chunk-6c46d2d3":"a6d2d92d","chunk-6d49bd8c":"086be20a","chunk-6e3ae64a":"33894910","chunk-6f753ec7":"9709aaea","chunk-6fbdfde8":"42079fb3","error":"31d6cfe0","home":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
